import React from "react";
import { Toaster } from "sonner";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import LoginPage from "@/pages/LoginPage";
import OnboardingPage from "@/pages/OnboardingPage";
import AttendeesPage from "@/pages/AttendeesPage";
import AttendeeDetailPage from "@/pages/AttendeeDetailPage";
import MatchesPage from "@/pages/MatchesPage";
import AdminPage from "@/pages/AdminPage";
import ProfilePage from "@/pages/ProfilePage";

const Loading = () => (
  <div className="min-h-screen flex items-center justify-center">
    <div className="overline">Loading…</div>
  </div>
);

const Protected = ({ children, adminOnly = false }) => {
  const { user, loading } = useAuth();
  if (loading) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  if (!user.profile_complete && !adminOnly && !user.is_admin) return <Navigate to="/onboarding" replace />;
  if (adminOnly && !user.is_admin) return <Navigate to="/attendees" replace />;
  return children;
};

const PublicOnly = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <Loading />;
  if (user) {
    if (user.is_admin) return <Navigate to="/admin" replace />;
    if (!user.profile_complete) return <Navigate to="/onboarding" replace />;
    return <Navigate to="/attendees" replace />;
  }
  return children;
};

function App() {
  return (
    <div className="App">
      <Toaster position="top-center" />
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Navigate to="/attendees" replace />} />
            <Route path="/login" element={<PublicOnly><LoginPage /></PublicOnly>} />
            <Route path="/onboarding" element={<OnboardingPage />} />
            <Route path="/attendees" element={<Protected><AttendeesPage /></Protected>} />
            <Route path="/attendees/:id" element={<Protected><AttendeeDetailPage /></Protected>} />
            <Route path="/matches" element={<Protected><MatchesPage /></Protected>} />
            <Route path="/profile" element={<Protected><ProfilePage /></Protected>} />
            <Route path="/admin" element={<Protected adminOnly><AdminPage /></Protected>} />
            <Route path="*" element={<Navigate to="/attendees" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
